import React from 'react'
import styled from 'styled-components'

interface CheckboxProps {
  isChecked?: boolean
  onChange: (_: string) => void
  isRequired?: boolean
}

export const CheckboxSlider = ({
  isChecked,
  onChange,
  isRequired,
}: CheckboxProps) => {
  return (
    <Container>
      <Label tabIndex="0" onClick={onChange}>
        <Input type="checkbox" />
        <Span isChecked={isChecked} isRequired={isRequired} />
      </Label>
    </Container>
  )
}

type StyledProps = {
  isChecked?: boolean
  isRequired?: boolean
}

const Container = styled.div<StyledProps>`
  word-break: break-all;
  box-sizing: border-box;
  user-select: none;
`

const Label = styled.div<any>`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 20px;
`

const Input = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`

const Span = styled.span.attrs((props: any) => ({
  className: props.size === 'tiny' ? 'mr-2' : 'mr-3',
}))<StyledProps>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;

  &:before {
    position: absolute;
    content: '';
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: ${({ theme }) => theme.palette.secondary};
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }

  ${(props) =>
    props.isRequired &&
    `
    &:before {
      opacity: 0.6;
    }
  `}

  ${(props) =>
    props.isChecked &&
    `
  background-color: ${props.theme.palette.silverTree};

  &:before {
    -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
  background-color: ${props.theme.palette.secondary};
  };
  `};
`
